// Census data constants for use in Quotas.
// If these values are changed, the relevant user-facing help docs should be updated.
// Also be sure that each set adds up to 100% and is tested for rounding issues.
export const censusData = {
  GB: {
    age: {
      '18-20': 4,
      '21-29': 14,
      '30-39': 17,
      '40-54': 25,
      '55+': 40,
    },
    gender: {
      male: 51,
      female: 49,
      other: 0,
      nonbinary: 0,
      transmale: 0,
      transfemale: 0,
      prefernottoanswer: 0,
    },
    ethnicity: {
      americanindianalaskannative: 0,
      hispaniclatino: 0,
      blackorafricanamerican: 4,
      asianpacificislander: 9,
      whitecaucasian: 84,
      middleeastern: 1,
      multipleethnicity: 2,
      prefernotdisclose: 0,
    },
  },
  US: {
    age: {
      '18-20': 5,
      '21-29': 15,
      '30-39': 17,
      '40-54': 24,
      '55+': 39,
    },
    gender: {
      male: 49,
      female: 51,
      other: 0,
      nonbinary: 0,
      transmale: 0,
      transfemale: 0,
      prefernottoanswer: 0,
    },
    ethnicity: {
      americanindianalaskannative: 1,
      hispaniclatino: 19,
      blackorafricanamerican: 12,
      asianpacificislander: 6,
      whitecaucasian: 58,
      middleeastern: 0,
      multipleethnicity: 4,
      prefernotdisclose: 0,
    },
  },
};
